export function dateFormatterTooltip(lng: string, customTooltipDateFormat?: Intl.DateTimeFormatOptions): Intl.DateTimeFormat {
    const standardFormat: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    };

    return new Intl.DateTimeFormat(lng, customTooltipDateFormat ?? standardFormat);
}
export function dateFormatterHoursAndMinutes(lng: string): Intl.DateTimeFormat {
    return new Intl.DateTimeFormat(lng, {
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function dateFormatterDaysAndMonths(lng: string): Intl.DateTimeFormat {
    return new Intl.DateTimeFormat(lng, {
        month: "2-digit",
        day: "2-digit",
    });
}

export function dateFormatterYears(lng: string): Intl.DateTimeFormat {
    return new Intl.DateTimeFormat(lng, {
        year: "numeric",
    });
}
